var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cmp_list_cla" },
    [
      _c("zk-table", {
        ref: "table",
        attrs: {
          columns: _vm.columnData,
          data: _vm.tableData,
          headerAlign: "center"
        },
        on: { rowClick: _vm.rowClick }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-margin-top" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "pager-count": 5,
              "current-page": _vm.pager.curPage,
              "page-size": _vm.pager.pageSize,
              total: _vm.pager.total
            },
            on: {
              "size-change": _vm.changePageSize,
              "current-change": _vm.changePage
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "verifyComponent",
        {
          attrs: {
            dialogVisible: _vm.dialogVisible,
            checkType: _vm.checkType,
            isEmail: _vm.isEmail,
            title: _vm.title,
            formData: _vm.formData,
            sourceOrgin: _vm.sourceOrgin,
            isChange: _vm.isChange
          },
          on: { onclose: _vm.onclose, submit: _vm.submitForm }
        },
        [
          _c(
            "div",
            {
              staticStyle: { "margin-bottom": "15px" },
              attrs: { slot: "tip" },
              slot: "tip"
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("companyList.deletCompany")) +
                  "\n    "
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0618fdfa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0618fdfa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tenantManager/companyInfo/companyList.vue
// module id = null
// module chunks = 